

































import { Component, Vue, Prop } from "vue-property-decorator";
import { IImage } from "@/store/types";
import { ILogo } from "@/models/logos";
import { IProduct } from "@/models/products";
import { IProvisionProvider } from "@/models/provisioning";
import { LogoSize, LogoType } from "@/data/enums/logos";
import _ from "@/boot/lodash";

@Component
export default class ProductImage extends Vue {
  // Props

  @Prop({ required: true })
  public product!: IProduct;

  @Prop({ default: null })
  public provisionProvider!: IProvisionProvider;

  @Prop({ default: 100 })
  public size!: number;

  @Prop({ default: true })
  public showProvisionLogo!: boolean;

  @Prop({ default: "1rem" })
  public readonly bottomLeftSize!: number;

  @Prop({ default: "1.25rem" })
  public readonly bottomRightSize!: number;

  @Prop({ default: false })
  public readonly bottomRightIsRounded!: boolean;

  // Computed

  public get productName() {
    return this.product?.name_translated || this.product?.name || "";
  }

  public get productImageSrc(): IImage["full_url"] | undefined {
    const src = _.get(this.product, "image.full_url");
    return src ? `${src}?size=${this.size}x${this.size}` : src;
  }

  public get providerLogoSrc(): ILogo["url"] | undefined {
    return _.get(
      _.find(this.provisionProvider?.logos, l => {
        if (l.type === LogoType.ICON && l.size === LogoSize.ONE_X) return true;
        return false;
      }),
      "url"
    );
  }
}
